/* globals window */

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const retry = async (
  importFunction,
  retriesLeft = 5,
  interval = 1000
) => {
  try {
    return await importFunction();
  } catch (err) {
    if (retriesLeft) {
      await wait(interval);
      return retry(importFunction, retriesLeft - 1, interval);
    }

    throw new Error(err);
  }
};

export const getRouterType = () => {
  if (window.commerce7?.router === 'Hash') {
    return 'Hash';
  }
  return 'Browser';
};

export const getProfileHref = (link) => {
  const routerType = getRouterType();
  const base = getProfileBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getProfilePath = (path) => {
  const routerType = getRouterType();
  const base = getProfileBase();

  if (routerType === 'Hash') {
    return path;
  }

  return `${base}${path}`;
};

export const getProfileBase = () => {
  if (window.commerce7?.routes?.profile) {
    valiateBaseRoute(window.commerce7.routes.profile, 'profile');
    return window.commerce7.routes.profile;
  }

  return '/profile';
};

export const getProductHref = (link) => {
  const routerType = getRouterType();
  const base = getProductBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getProductPath = (path) => {
  const routerType = getRouterType();
  const base = getProductBase();

  if (routerType === 'Hash') {
    return path;
  }

  return `${base}${path}`;
};

export const getProductBase = () => {
  if (window.commerce7?.routes?.product) {
    valiateBaseRoute(window.commerce7.routes.product, 'product');
    return window.commerce7.routes.product;
  }

  return '/product';
};

export const getReservationHref = (link) => {
  const routerType = getRouterType();
  const base = getReservationBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getReservationPath = (path) => {
  const routerType = getRouterType();
  const base = getReservationBase();

  if (routerType === 'Hash') {
    return path;
  }

  return `${base}${path}`;
};

export const getReservationBase = () => {
  if (window.commerce7?.routes?.reservation) {
    valiateBaseRoute(window.commerce7.routes.reservation, 'reservation');
    return window.commerce7.routes.reservation;
  }

  return '/reservation';
};

export const getCheckoutHref = (link) => {
  const routerType = getRouterType();
  const base = getCheckoutBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getClubSignupSharedHref = (link) => {
  const routerType = getRouterType();
  const base = getCheckoutBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getCheckoutPath = (path) => {
  const routerType = getRouterType();
  const base = getCheckoutBase();

  if (routerType === 'Hash') {
    return path;
  }

  return `${base}${path}`;
};

export const getCheckoutBase = () => {
  if (window.commerce7?.routes?.checkout) {
    valiateBaseRoute(window.commerce7.routes.checkout, 'checkout');
    return window.commerce7.routes.checkout;
  }

  return '/checkout';
};

export const getCollectionBase = () => {
  if (window.commerce7?.routes?.collection) {
    valiateBaseRoute(window.commerce7.routes.collection, 'collection');
    return window.commerce7.routes.collection;
  }

  return '/collection';
};

export const getCollectionHref = (link) => {
  const routerType = getRouterType();
  const base = getCollectionBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getCartHref = (link) => {
  const routerType = getRouterType();
  const base = getCartBase();

  if (routerType === 'Hash') {
    return `${base}#${link}`;
  }

  return `${base}${link}`;
};

export const getCartBase = () => {
  if (window.commerce7?.routes?.cart) {
    valiateBaseRoute(window.commerce7.routes.cart, 'cart');
    return window.commerce7.routes.cart;
  }

  return '/cart';
};

export const getClubBase = () => {
  if (window.commerce7?.routes?.club) {
    valiateBaseRoute(window.commerce7.routes.club, 'club');
    return window.commerce7.routes.club;
  }

  return '/club';
};

const valiateBaseRoute = (value, route) => {
  if (!value.startsWith('/')) {
    throw new Error(`Custom ${route} route should start with a leading slash`);
  }
  if (value.endsWith('/')) {
    throw new Error(
      `Custom ${route} route should not end with a trailing slash`
    );
  }
};
